import {
  UPDATE_CONTACTIBILITY_REQUEST,
  UPDATE_CONTACTIBILITY_SUCCESS,
  UPDATE_CONTACTIBILITY_FAILURE,
  RESET_CONTACTIBILITY_MESSAGE,
} from "../../actionTypes";

const initialState = {
  status: false,
  isLoading: false,
  message: "",
};

const updateContactibilityReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_CONTACTIBILITY_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case UPDATE_CONTACTIBILITY_SUCCESS:
      console.log("us", action.payload);
      return {
        ...state,
        isLoading: false,
        status: action.payload.status,
        message: action.payload.message,
      };
    case UPDATE_CONTACTIBILITY_FAILURE:
      return {
        ...state,
        isLoading: false,
        status: action.payload.status,
        message: action.payload.message,
      };
    case RESET_CONTACTIBILITY_MESSAGE:
      return {
        ...state,
        status: false,
        isLoading: false,
        message: "",
      };
    default:
      return state;
  }
};

export default updateContactibilityReducer;
